import React from "react";
import Switch from "../FormElements/Switch";
import NumberInput from "../FormElements/NumberInput";

export default class LearningPlanBuilderCourse extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  render() {
    const { item, course, courses = [] } = this.props;
    const { learnable_id, pretest, posttest } = item;

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <select
              className="form-control"
              name="learnable_id"
              value={learnable_id}
              onChange={this.onChange}
            >
              <option value="">{I18n.t("admin.select_course")}</option>
              {courses.map((course) => {
                return (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        {course ? (
          <div>
            <div className="row" style={{ marginTop: "15px" }}>
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label>{I18n.t("pretest")}</label>
                      <Switch
                        id={`pretest-${learnable_id}`}
                        isOn={pretest}
                        handleToggle={() => {
                          this.onChange({
                            target: {
                              name: "pretest",
                              value: !pretest,
                            },
                          });
                        }}
                      />
                    </div>
                    {pretest ? this.renderTestInputs("pretest") : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div
                  className="card"
                  style={{
                    marginBottom: "5px",
                  }}
                >
                  <div className="card-body">
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label>{I18n.t("posttest")}</label>
                      <Switch
                        id={`posttest-${learnable_id}`}
                        isOn={posttest}
                        handleToggle={() => {
                          this.onChange({
                            target: {
                              name: "posttest",
                              value: !posttest,
                            },
                          });
                        }}
                      />
                    </div>
                    {posttest ? this.renderTestInputs("posttest") : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderTestInputs(test_type) {
    const { course, item } = this.props;
    const question_pool =
      typeof item[`${test_type}_question_pool`] !== "undefined"
        ? item[`${test_type}_question_pool`]
        : "course";
    return (
      <div className="row" style={{ clear: "both", marginTop: "15px" }}>
        <div className="col-sm-2">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{I18n.t("admin.questions")}</label>
            <br />
            <NumberInput
              style={{ maxWidth: "88px" }}
              name={`${test_type}_number_of_questions`}
              min={1}
              max={
                question_pool === "course"
                  ? course.number_of_questions
                  : course.max_number_of_questions_per_article
              }
              value={
                typeof item[`${test_type}_number_of_questions`] !== "undefined"
                  ? item[`${test_type}_number_of_questions`]
                  : 1
              }
              onChange={this.onChange}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{I18n.t("admin.from")}</label>
            <br />
            <select
              className="form-control"
              name={`${test_type}_question_pool`}
              value={question_pool}
              onChange={this.onChange}
            >
              {/* <option value="">{I18n.t("admin.please_select")}</option> */}
              <option value="course">
                {I18n.t("admin.from_course_question_pool")}
              </option>
              {/* <option value="article">
                {I18n.t("admin.from_each_article")}
              </option> */}
            </select>
          </div>
        </div>
        {test_type == "posttest" ? (
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("passing_score")}</label>
              <br />
              <NumberInput
                style={{ maxWidth: "88px" }}
                name={`${test_type}_passing_score`}
                min={0}
                max={100}
                value={
                  typeof item[`${test_type}_passing_score`] !== "undefined"
                    ? item[`${test_type}_passing_score`]
                    : 80
                }
                onChange={this.onChange}
              />
            </div>
          </div>
        ) : null}
        {test_type == "posttest" ? (
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label title={I18n.t("number_passed_posttests_helper_text")}>
                {I18n.t("number_passed_posttests")}
              </label>
              <br />
              <select
                className="form-control"
                style={{ maxWidth: "88px" }}
                name="passed_post_tests_for_completion"
                value={
                  typeof item["passed_post_tests_for_completion"] !==
                  "undefined"
                    ? item["passed_post_tests_for_completion"]
                    : 1
                }
                onChange={this.onChange}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onChange(event) {
    const new_item = {
      ...this.props.item,
      [event.target.name]: event.target.value,
    };
    this.props.onChangeItem(new_item);
  }
}
